<template>
  <div class="c-trend-chart">
    <slot name="ariaTitle"></slot>
    <div v-for="(cssClass, i) in spread" :key="i" :class="cssClass" />
  </div>
</template>

<script>
export default {
  name: 'c-trend-chart',
  props: {
    values: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      map: {
        '-1': 'negative',
        '-0.5': 'semi-negative',
        '0': '',
        '0.5': 'semi-positive',
        '1': 'positive'
      }
    };
  },
  computed: {
    spread() {
      return this.values.map(val => this.map[val]);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-trend-chart';
</style>
